var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgArrowForward = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none"
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "arrow_forward_svg__a",
  width: 16,
  height: 16,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#D9D9D9",
  d: "M0 0h16v16H0z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#arrow_forward_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#009EE7",
  d: "M10.784 8.667h-7.45a.645.645 0 0 1-.475-.192A.645.645 0 0 1 2.667 8c0-.189.064-.347.192-.475a.645.645 0 0 1 .475-.192h7.45L7.517 4.067a.61.61 0 0 1-.192-.467.67.67 0 0 1 .209-.467A.703.703 0 0 1 8 2.942a.61.61 0 0 1 .467.191l4.4 4.4a.585.585 0 0 1 .142.217.74.74 0 0 1 .041.25.74.74 0 0 1-.041.25.585.585 0 0 1-.142.217l-4.4 4.4a.622.622 0 0 1-.458.183.679.679 0 0 1-.475-.183.649.649 0 0 1-.2-.475.65.65 0 0 1 .2-.475l3.25-3.25Z"
}))));
export default SvgArrowForward;